import { useField } from 'formik';

import { InsightsBox } from '@@/InsightsBox';
import { FormSection } from '@@/form-components/FormSection/FormSection';
import { SwitchField } from '@@/form-components/SwitchField';

const fieldKey = 'Observability';

// ensure to add a disclaimer with the info of not scale tested and only for non-production environments to the tooltip
export function EnableObservabilitySection() {
  const [{ value }, , { setValue }] = useField<boolean>(fieldKey);

  return (
    <FormSection title="Observability">
      <InsightsBox
        header="Disclaimer"
        type="slim"
        content={
          <div className="space-y-3">
            <div>
              While this feature is called Observability, it currently only
              supports alerting; additional observability capabilities will be
              introduced in future updates.
            </div>
          </div>
        }
        className="mb-3"
      />

      <div className="form-group">
        <div className="col-sm-12">
          <SwitchField
            label="Observability"
            data-cy="enable-observability-switch"
            name={fieldKey}
            labelClass="col-sm-3 col-lg-2"
            checked={value}
            onChange={(checked) => setValue(checked)}
          />
        </div>
      </div>
      <div className="text-muted small">
        Enable Observability for Portainer Alert Manager to proactively monitor
        environments for downtime or critical resource consumption thresholds,
        then receive notifications via Slack, Microsoft Teams, email, or
        webhook.
      </div>
    </FormSection>
  );
}
